// src/codebase/components/FindingsTable.jsx
// Migrated from a hand-rolled <table> onto the shared DataTable (promoted
// from golive) — this gets sorting + pagination for free instead of
// dumping every finding into one unpaginated table.
import { useMemo } from "react";
import DataTable from "../../shared/ui/DataTable/index.jsx";
import Badge from "./Badge.jsx";
import { getSeverityTone } from "../../shared/utils/colorScales";

export default function FindingsTable({ items }) {
  const columns = useMemo(
    () => [
      {
        accessorKey: "severity",
        header: "Severity",
        width: 110,
        cell: ({ getValue }) => <Badge tone={getSeverityTone(getValue())} dot>{getValue()}</Badge>,
      },
      {
        accessorKey: "category",
        header: "Category",
        width: 140,
        cell: ({ getValue }) => <span className="mono small">{getValue()}</span>,
      },
      { accessorKey: "message", header: "Message" },
      {
        accessorKey: "file_path",
        header: "File",
        width: 360,
        cell: ({ getValue }) => <span className="mono small">{getValue() || "—"}</span>,
      },
      {
        accessorKey: "line",
        header: "Line",
        width: 80,
        align: "center",
        cell: ({ getValue }) => <span className="mono small">{getValue() ?? "—"}</span>,
      },
    ],
    []
  );

  if (!items?.length) {
    return <div className="muted">No findings to display.</div>;
  }

  return (
    <DataTable
      table={{ columns, rows: items }}
      canSearch
      entriesPerPage={{ defaultValue: 25, entries: [10, 25, 50, 100] }}
      emptyMessage="No findings to display."
    />
  );
}
